// useOrderAlerts.js — custom hook to drop into your component

import { useEffect, useRef, useCallback } from 'react';

// Map status → sound file path
const STATUS_SOUNDS = {
    new_order:  '/sounds/orderplaced.ogg',
    cancelled:  '/sounds/ordercancelledbystore.ogg',
    ready_order: '/sounds/orderready.ogg'
};

export function useOrderAlerts(updatedOrders, setUpdatedOrders) {
    const audioRef = useRef(null);
    const intervalRef = useRef(null);

    const stopSound = useCallback(() => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
        clearInterval(intervalRef.current);
    }, []);

    const playSound = useCallback((status) => {
        stopSound();
        const src = STATUS_SOUNDS[status];
        if (!src) return;
        const audio = new Audio(src);
        audioRef.current = audio;
        // loop by replaying every X seconds
        audio.play().catch(() => {});
        console.log("audio is playing", src);
        intervalRef.current = setInterval(() => {
            audio.currentTime = 0;
            audio.play().catch(() => {});
        }, 4000); // re-ping every 3s
    }, [stopSound]);

    // When updatedOrders changes, play sound based on FIRST item's status
    useEffect(() => {
        if (updatedOrders.length === 0) {
            stopSound();
            return;
        }
        const firstStatus = updatedOrders[0].status;
        playSound(firstStatus);
    }, [updatedOrders, playSound, stopSound]);

    // Cleanup on unmount
    useEffect(() => () => stopSound(), [stopSound]);

    // Call this on hover of an order card
    const dismissOrder = useCallback((id) => {
        setUpdatedOrders(prev => prev.filter(o => o.id !== id));
    }, [setUpdatedOrders]);

    return { dismissOrder };
}